import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuardNoTokenService {

  constructor(private cookieService: CookieService, private router: Router) { }

  canActivate(): boolean {
    const tokenExists = this.cookieService.check('sessionToken');

    if (!tokenExists) {
      return true; // Permite el acceso si no hay token
    } else {
      this.router.navigate(['/usuarios']);
      return false;
    }
  }
}
